import { render, staticRenderFns } from "./BimetallicStripViz.vue?vue&type=template&id=4b5e10dc&scoped=true"
import script from "./BimetallicStripViz.vue?vue&type=script&lang=js"
export * from "./BimetallicStripViz.vue?vue&type=script&lang=js"
import style0 from "./BimetallicStripViz.vue?vue&type=style&index=0&id=4b5e10dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e10dc",
  null
  
)

export default component.exports